/**
 * @description 中文 切换 语言
 * @date 2022-12-09 星期五 阴
 */

export const lang = {
	title: `MD5在线解密文档`,
	copy: `复制`,
	prompt: `提示`,
	confirm: `确定`,
	automatic: `自动`,
	copy_succeed: `复制成功`,
	copyDataMsg: `已复制到粘贴板`,
	loginFailure: `您登录失效了，请重新登录`,
	goHome: `返回首页`,
	header: {
		myCenter: `个人中心`,
		changePwd: `修改密码`,
		mypoints: `我的积分记录`,
		loginOut: `退出登录`,
		index: `首页`,
		login: `登录`,
		tool: `在线工具`,
		batch: `在线批量解密`,
		plaintextUpload: `明文提交`,
		api: `API`,
	},
	footerInfo: {
		warnText: `本站所有功能及数据仅可用于密码学研究及信息安全评估,数据均来自随机生成，严禁用于任何非法用途,如有违反本站不承担任何责任！`,
		contactUs: `联系我们`,
		rightsAll: `版权所有.`,
		aq: ` 桂ICP备19009338号-6`,
	},
	// 个人中心
	myCenter: {
		title: `个人中心`,
		myTotal: `我的积分`,
		shareGetPoints: `分享获取积分`,
		shareExplain: `分享网站链接得到20积分`,
		share: `分享`,
		rechargeGetShare: `充值获取积分`,
		rechargeExplain: `充值100元换取10000积分，仅支持微信支付`,
		recharge: `充值`,
		integralRecord: `我的积分记录`,
		getRecords: `获取记录`,
		noData: `暂无数据`,
		usageRecord: `使用记录`,
		forgotpwd: `修改密码`,
		isloginOut: `您是否要退出登录?`,
		confirm: `确定退出登录`,
		cancel: `取消`,
		successLogOut: `成功退出登录!`,
	},
	// 忘记密码
	// forgotpwd: {
	//   title: `一站加密文加解密平台`,
	//   forgotpwd: `忘记密码`,
	//   backHomepage: `返回首页`,
	//   email: `邮箱`,
	//   errEmail: `请输入正确的邮件格式`,
	//   password: `密码`,
	//   errPwd: `请输入密码`,
	//   againPwd: `确认密码`,
	//   againPwdPlder: `请输入确认密码`,
	//   sent: `已发送`,
	//   nextStep: `下一步`,
	//   pass_mailbox: `恭喜您，密码修改成功`,
	//   sent_text: `赶紧去登录吧！`,
	//   errCaptcha: `请输入验证码`,
	//   successCaptcha: `邮箱验证码发送成功！`,
	//   errTiptext: `密码和确认密码不一致`,
	//   goLogin: `去登录`,
	// },
	// 首页
	homePage: {
		selectBox: `请选择`,
		query: `查询`,
		placeholder: `请输入需要解密的密文`,
		result: `解密结果`,
		decrypt: `解密`,
		captcha: `验证码`,
		captchaPlaceholder: `请输入验证码`,
		// 搜索结果
		encryptionType: `加密类型`,
		encryptionLabel: `原文字符串`,
		copy: `复制`,
		copyClick: `点击复制`,
		originalString: `原文字符串`,
		lowerCase16: `16位小写`,
		upperCase16: `16位大写`,
		lowerCase32: `32位小写`,
		upperCase32: `32位大写`,
		login: `登录`,
		decryptionFailed: `解密失败`,
		// 公共栏区域
		noticeText: `公告`,
		noticeContent: `本站支持多种在线解密算法，快速，准确，稳定，免费；数据库不断更新，欢迎查询！更多问题欢迎咨询：官方QQ交流群1：857548361，官方QQ交流群2：280409281`,
		joinQQAlt: `点击加入QQ群`,
		joinQQText: `加入QQ群`,
		joinWeChatAlt: `点击加入微信群`,
		joinWeChatText: `加入微信群`,
		currentTypeVal: `选择类型···`,
		errText: `请勿输入中文`,
		errDecode: `请求解码失败`,
		successLogin: `登录成功！`,
	},
	// 在线工具tool
	tool: {
		moreTools: `更多工具`,
	},
	// 在线批量解密
	decryption: {
		selectEncryptionType: `选择加密类型`,
		currentTypeVal: `点击选择解密类型`,
		captcha: `验证码`,
		captchaPlaceholder: `请输入验证码`,
		submitDecryption: `提交解密`,
		tiptextBox: `说明：批量解密每一条解密需要10积分。`,
		sourcetextHead: `原文（不超过200行）`,
		decryptionResult: `解密结果`,
		failure: `解密失败`,
		copy: `复制`,
		noData: `无数据`,
		automatic: `自动`,
		msgTitle: `提示`,
		verifyCodeMsg: `请填写验证码`,
		enCodeMsg: `解码字符串不能为空！`,
		noCpyData: `无数据，无法正常复制数据!`,
	},
	// 明文提交页面
	plaintextUpload: {
		plaintextUpload: `明文提交`,
		placeholder: `请输入明文密码`,
		plaintextSubmit: `明文提交`,
		warningText: `输入您知道的明文密码(如admin,123456，147258369等),收录相关密码的MD5密文，以便下次查询MD5密文,可以有效防止破解！请勿重复提交。`,
		note: `注：用户成功提交，可增加积分`,
		error: `请输入明文`,
		success: `明文密码上传成功`,
	},
	// 批量解密 API
	api: {
		api: `API接口`,
		callURL: `调用URL`,
		wrapperContent1: `支持最多200条密文,用逗号分隔`,
		wrapperContent2: `如果修改了密码，则参数key将发生变化`,
		wrapperContent3: `请求方式:POST`,
		wrapperContent4: `解密成功后, 解密结果将发送到对应的URL, 发送请求共三次, 每隔5秒钟请求一次, 如果响应'ok'则不再请求, 三次请求过后不再通知`,

		tipTitle: `错误代码`,
		errorCodeTitle: `解密多条结果用TAB分隔。其它情况则返回字符串“ERROR-CODE:"+数字代码。列举如下:`,

		errorCode1: `解密失败`,
		errorCode2: `无效的KEY`,
		errorCode3: `积分不足`,
		errorCode4: `条数超过200条`,
		errorCode5: `解密服务器故障`,
		errorCode6: `其它错误`,
		important: `重要提醒`,
		wrapperContent5: `本接口被严密监控，不得用于二次销售、网站代查、公开查询等情形，例如有假冒本网站提供查询，实际上是后台用本接口偷偷到本网站查询等， 一经发现立即封号不予以退款。`,
		wrapperContent6: `本接口每条查询，不论是否解密成功都将进行扣除积分`,
		wrapperContent7: `本接口每条查询如有重复，将重复进行扣除积分，请注意检查重复密文`,
		wrapperContent8: `本接口查询多条密文使用的是按“自动”类型查询，可查询Md5,Sha1,Sha256,Sha512,mysql,mysql5等类型`,
		type_label1: `参数名`,
		type_label2: `必选`,
		type_label3: `类型`,
		type_label4: `说明`,
		isRequire: `是`,
		desc1: `你的接收结果的url`,
		desc2: `登陆后台后显示`,
		desc3: `你的密文, 逗号分开`,
		cryptList_1: `Base64 编码`,
		cryptList_2: `Base64 解码`,
		message: '请输入正确的Base64 解码！',
	},
	// 登陆
	login: {
		title: `欢迎登录`,
		email: `邮箱`,
		emailPlaceholder: `请输入正确的邮件格式`,
		password: `密码`,
		pwdPlaceholder: `请输入密码`,
		captcha: `验证码`,
		captchaPlaceholder: `请输入验证码`,
		consentProtocol: `我已审阅并同意`,
		protocol: `用户协议`,
		privacyPolicy: `《隐私条款》`,
		login: `登录`,
		gobacklogin: `返回登录`,
		register: `没有账号,`,
		goregister: `去注册？`,
		goForgotpwd: `忘记密码？`,
		gobackBack: `返回首页`,
		noNumber: `没有账号，`,
		weChatLogin: `微信登录`,
		qqLogin: `QQ登录`,
		otherLogin: `其他登录`,
		loginType1: `欢迎注册`,
		loginType2: `忘记密码`,
		message: `恭喜你，登录成功!`,
		errTiptext1: `请输入邮箱`,
		errTiptext2: `请输入密码`,
		errTiptext3: `请填写验证码`,
		errTiptext4: `请勾选协议选项`,
		and: `和`,
		againlogin: `抱歉您登录已经失效，需要您重新登录`,
		Tips: `提示`,
		gologin: `前往登录`,
		cancel: `取消`,
	},
	// 注册
	registerType: `欢迎注册`,
	loginType: `欢迎登录`,
	register: {
		email: `邮箱`,
		emailPlaceholder: `请输入正确的邮箱格式`,
		password: `密码`,
		againPassword: `确认密码`,
		pwdPlaceholder: `请输入确认密码`,
		captcha: `验证码`,
		captchaPlaceholder: `请输入验证码`,
		getCaptcha: `获取验证码`,
		sent: `已发送`,
		register: `注册`,
		goLogin: `已有账号，去登录！`,
		msg1: `恭喜您成功注册,正在前往登录`,
		msg2: `邮箱验证码已经发送，请耐心等待查收验证码`,
		msg3: `请输入邮箱`,
		msg4: `请输入密码`,
		msg5: `请输入确认密码`,
		msg6: `密码和确认密码不一致`,
		msg7: `注册成功`,
	},
	// 忘记密码
	forgotPwd: {
		forgotPwd_title: `一站加密文加解密平台`,
		forgotpwd: `忘记密码`,
		email: `邮箱`,
		emailPlaceholder: `请输入正确的邮件格式`,
		password: `密码`,
		errPwd: `请输入密码`,
		againPassword: `确认密码`,
		captcha: `验证码`,
		captchaPlaceholder: `请输入验证码`,
		getCaptcha: `获取验证码`,
		nextStep: `下一步`,
		sent: `已发送`,
		title: `恭喜您，密码修改成功`,
		tologin: `恭喜您，密码修改成功,请你再次登录!`,
		sentText: `赶紧去登录吧！`,
		goLogin: `去登录！`,
		errEmail: `请输入邮箱账号`,
		msg: `邮箱验证码发送成功！`,
		msg4: `请输入密码`,
		msg5: `请输入确认密码`,
		msg6: `密码和确认密码不一致`,
		retype: `重新输入`,
		confirmEdit: `确认修改`,
	},
	// 修改密码
	changePsw: {
		changePsw: `修改密码`,
		password: `密码`,
		confirmPassword: `重新输入`,
		inputone: `请输入正确的密码`,
		inputotwo: `请再次输入正确的密码`,
		msg: `修改密码成功!请您重新登录`,
		gohomg: `返回首页`,
		confirmEdit: `确认修改`,
	},
	// 微信登录扫一扫
	wxLogin: {
		wechatScan: `微信扫一扫登录`,
		firstSetEmail: `首次登录需要绑定邮箱`,
		email: `邮箱`,
		emailPlaceholder: `请输入正确的邮件格式`,
		captcha: `验证码`,
		captchaPlaceholder: `邮箱验证码`,
		getCaptcha: `获取验证码`,
		sent: `已发送`,
		login: `登录`,
		errEmail: `请填写邮箱！`,
		errCode: `请填写验证码！`,
		successLogin: `登录成功！`,
		msg2: `邮箱验证码已经发送，请耐心等待查收验证码`,
	},
	//微信充值
	wechatpayup: {
		username: `充值账号：`,
		currentScore: `当前积分：`,
		inputAmount: `请输入金额`,
		money: `自定义金额`,
		rechargeType: `充值的方式`,
		wechatRcharge: `微信充值`,
		earnPoints: `获得积分`,
		integral: `积分`,
		giving: `赠送`,
		total: `共`,
		confirmWechatpay: `确认支付`,
	},
	// tool工具
	goback: `返回`,
	gobackBack: `返回上一页`,
	copyResult: `复制结果`,
	clear: `清空`,
	getRes: `获取结果`,
	encrypt: `加密`,
	key: `密钥`,
	result: `结果`,
	websocket: {
		title: `大小写转换`,
		textarea: `请输入字母大小写转换...`,
		lowerCase: `小写`,
		upperCase: `大写`,
		initialLowerCase: `首字母大写`,
		initialUpperCase: `单词首字母大写`,
		//  websocket 编码解码 组件
		configurationStatus: `服务器配置 状态`,
		connectSuccess: `连接成功`,
		connectClose: `连接关闭`,
		websocketInput: `请输入websocket地址`,
		websocketURL: `服务地址`,
		websocketContent: `输入要发送到服务端的内容`,
		send: `发送`,
		deBug: `调试消息`,
		msgLog: `消息记录`,
		msgClear: `清空消息`,
		sendMsg: `发送消息`,
		receiveMsg: `收到消息`,
		open: `开启连接`,
		break: `断开连接`,
		now: `正在连接...`,
		inputState: `地址不能为空！`,
		soleInfo1: `连接已经建立，不需要重复连接`,
		soleInfo2: `连接出错，请查看控制台`,
		soleInfo3: `正在断开连接...`,
		soleInfo4: `发送了：`,
		soleInfo5: `连接成功`,
		soleInfo6: `请输入有效的websocket地址！`,
		soleInfo7: `连接已断开`,
		//   摩斯电码 编码解码 组件
		codeContent: `编码/解码的内容`,
		code: `编码`,
		decode: `解码`,
		error1: `请输入内容！`,
		// 源代码在线审计页面
		uploadFile: `上传文件`,
		auditStatus: `审计状态`,
		download: `下载报告`,
		uploadText: `将文件拖到此处，或`,
		clickUpload: `点击上传`,
		uploadTip: `请将代码压缩为ZIP格式再上传，文件大小不超过2Mb`,
		uploadFoot: `工具仅支持PHP，Javascript语言的代码`,
		codeAuditFileName: `当前审计的文件：`,
		audit: `审计中`,
		auditDone: `审计完成`,
		auditFail: `审计失败`,
		underAudits: `正在审计中...`,
		checkState: `手动查询状态`,
		checkFailState: `您确定要重新上传文件吗？`,
		goBackUpload: `返回重新上传`,
		auditError: `审计发现异常`,
		auditSuccess: `审计完成`,
		downloadAudit: `下载审计报告`,
		goBackUploadFile: `您确定要重新上传文件吗？`,
		reUpload: `重新上传`,

		ascii: `请输入ASCII码...`,
		ciphertext: `明文/密文`,
		error2: `请输入编码内容！`,
		error3: `密钥不能为空！`,
		error4: `请输入明文/密文`,
		des: `DES 加密&解密`,
		aes: `AES 加密/解密`,
		// 哈希 MD5 组件
		encryptionInput: `请输入要加密的字符串，多个以换行区分`,
		encryptionRes: `加密结果在此显示`,
	},
	desc_page: {
		desc_title: `查询MD5`,
		second_title: `反向查询`,
		depict_text: `针对md5等全球通用公开的加密算法进行反向查询`,
		depict_text_cot: `建立了密文对应查询数据库，很多复杂密文只有本站才可查询，支持多种算法，实时查询记录超过24万亿条，共占用160T硬盘，成功率95`,
		article_title1: `实时查询解密范围`,
		data_centet_p1: `山东大学王小云教授发现了md5的碰撞原理震惊了世界，本站就是专门针对全球通用的md5等算法进行反向解密，实时查询拥有全世界最大的数据库，实测解密成功率在95`,
		data_centet_p2: `本站还支持dz、vb、mssql等实时查询和实时批量解密，此类带salt的加密类型，由于算法的特殊性，一般方法无法建库，本站采用独特技术，在保证最高成功率的前提下，实现了实时批量解密，这在全球都是绝无仅有的，2010年正式上线以来，至今没有其它任何一家真正实现了此功能。`,
		data_centet_p3: `山东大学王小云教授发现了md5的碰撞原理震惊了世界，本站就是专门针对全球通用的md5等算法进行反向解密，实时查询拥有全世界最大的数据库，实测解密成功率在95`,
		data_centet_p4: `国内从来不缺小偷和小人，本站被大量抄袭，大家可任意测试，任意对比，本站的解密速度、解密成功率是无与伦比的。此类网站完全用技术说话，完全用数据说话，但小白太多，新用户不知道我们的实力。`,
		article_title2: `本站支持的密msg及格式说明`,
		attention_centet_p1: `1）如果你不不知道密文类型，在首页查询时，密文类型选择"自动"即可，将尝试所有的密文类型，多试几条，解密成功提示真正的密文类型，除此以外则无法从一个32位等字符串判断密文类型。`,
		attention_centet_p2: `2）除了按以上直观方法判断密文类型，再无其它办法，请不要用任何方式咨询我们关于密文类型的问题。`,
		article_title3: `解密举例`,
		article_title4: `关于新的密文类型/加密算法`,
		article_centet_p1: `你们不是很牛吗,为什么我这个不能解密？不是骗子吧！"`,
		article_centet_p2: `本站只支持常用的加密算法，对于新的算法加密的密文，是无法解密的。更不可能根据无法查询的密文推断加密算法。`,
		article_centet_p3: `如果你知道新的加密算法，请根据网站底部的email和我们联系。需详细描述算法内容，最好是附上源码。除此以外，请举例说明，例如123456加密后的密文是什么。`,
		article_centet_p4: `只要加密算法明确，一般就可以解密。`,
		article_centet_p5: `本站可以在一天内增加新的类型。`,
		article_title5: `独有数据说明`,
		article_centet_p6: `本站的数据量比世界上任何其它网站都超过100倍以上，举个很简单的例子，任何网站很难收录到8位小写字母，而本站多个类型都已经收录8位以上小写字母`,
		article_centet_p7: `除此以外，本站筹建了独立服务器，收录了一批极为冷僻的数据，这些数据命中的几率非常低，因此相对成本要高出很多。但仍然按普通的计费。`,
		article_title6: `后台分布式解密`,
		article_centet_p8: `无论是在首页查询，或者通过在线网页或软件进行批量解密，只要是非salt类型查询失败的，将立即自动进入后台分布式云解密。用户只需过一段时间再次查询或再次进行批量解密即可。如果是登录后查询，则破解成功将自动发送邮件通知。`,
		article_centet_p9: `由于本站实时解密成功率已经相当高，实际上后台分布式解密的成功可能性是相当低的。`,

		fields_md5_label1: `收录内容`,
		fields_md5_label2: `说明`,
		fields_md5_label3: `数量`,
		items_md5_con1: `1-6位大小写字母+数字+特殊字符`,
		items_md5_con2: `7位小写字母+数字`,
		items_md5_con3: `8位小写字母+数字`,
		items_md5_con4: `9位小写字母`,
		items_md5_con5: `8-11位数字`,
		items_md5_con6: `1-15位其它数据`,
		items_md5_con7: `1-20位`,

		items_md5_msg1: `收录100%`,
		items_md5_msg2: `部分收录`,
		items_md5_msg3: `900G独家超大字典`,
	},
	// 隐私政策
	privacyPolicy: {
		title: `md5.cn隐私政策`,
		privacyPolicy: `隐私政策`,
		content: `<p>MD5.cn（“我们”）非常重视用户的隐私和个人信息保护。您在使用我们的产品与/或服务时，我们可能会收集和使用您的相关信息。我们希望通过《MD5.cn隐私政策》（“本隐私政策”）向您说明我们在您使用我们的产品与/或服务时如何收集、使用、保存这些信息，以及我们为您提供的访问、更新、删除和保护这些信息的方式。</p><p>本政策将帮助您了解以下内容：<p/><p><p>一、隐私保护原则</p><p>二、我们收集的信息</p><p>三、我们如何使用收集的信息</p><p>四、我们如何使用cookie及相关技术</p><p>五、您如何管理自己的信息</p><p>六、我们可能向您发送的信息</p><p>七、通知和修订</p></p><p>一、隐私保护原则</p><p>MD5.cn严格遵守法律法规、遵守消费者隐私法 (CCPA)、遵守通用数据保护条例GDPR，遵循以下隐私保护原则，为您提供更加安全、可靠的服务：</p><p>1、安全可靠：</p><p>我们竭尽全力通过合理有效的信息安全技术及管理流程，防止您的信息泄露、损毁、丢失。</p><p>2、自主选择：</p><p>我们为您提供便利的信息管理选项，以便您做出合适的选择，管理您的个人信息。</p><p>3、合理必要：</p><p>为了向您和其他用户提供更好的服务，我们仅收集必要的信息。</p><p>4、清晰透明：</p><p>我们努力使用简明易懂的表述，向您介绍隐私政策，以便您清晰地了解我们的信息处理方式。</p><p>二、我们收集的信息</p><p>我们根据合法、正当、必要的原则，仅收集实现产品功能所必要的信息：</p><p>1、您在注册账户时填写的信息</p><p>例如，您在注册账户时所填写的用户名、邮箱、IP等。</p><p>2、您在使用服务时上传的信息</p><p>例如，您在会员中心上传的头像，whois隐私删除申请、SEO中介优化师认证时上传的身份证图片或营业执照图片。</p><p>3、网站功能中所提交的信息</p><p>例如，您申请发票、申请SSL安全证书、SEO中介优化师认证时，填写内容中可能包含您的姓名、电话、公司等信息。下载中心身份认证、SEO中介申请提现时，填写内容中可能包含您的姓名和支付宝账号等信息。</p><p>4、第三方账号授权登录时捆绑的信息</p><p>例如：您通过微信登录、QQ登录、微博登录时，授权捆绑的昵称、头像、性别等信息。</p><p>5、您在维护分发内容时所提及的信息</p><p>例如，您需要修正和删除资讯平台分发的稿件时，填写的身份认证或公司认证信息。</p><p>我们的部分服务可能需要您提供特定的个人敏感信息来实现特定功能。若您选择不提供该类信息，则可能无法正常使用服务中的特定功能，但不影响您使用服务中的其他功能。若您主动提供您的个人敏感信息，即表示您同意我们按本政策所述目的和方式来处理您的个人敏感信息。</p><p>三、我们如何使用收集的信息</p><p>我们严格遵守法律法规的规定及与用户的约定，将收集的信息用于以下用途：</p><p>1、向您提供服务</p><p>2、满足您的定制化需求</p><p>包括且不限于网站需涉及到用户敏感信息的功能：</p><p>（1）会员中心绑定手机仅用于网站登录、找回密码、安全验证或实名验证</p><p>（2）会员中心申请发票页，提交的电话仅用于发票验证。</p><p>（3）whois隐私删除申请页、SEO中介优化师认证页，提交的身份证图片或营业执照图片仅用于功能验证。</p><p>（4）SSL管理中心个人信息页，提交的个人信息仅用于功能验证。</p><p>（5）下载中心身份认证、SEO中介申请提现页，提交的支付宝信息仅用于功能验证。</p><p>3、安全保障</p><p>例如，我们会将您的信息用于安全防范、存档备份、客户的安全服务等用途。</p><p>4、向您发送系统消息</p><p>5、向您推送定制类消息</p><p>例如，API消息预警功能，可能会涉及向您的邮箱、手机、微信发送消息。</p><p>在个人敏感数据使用上，我们会采用数据脱敏和加密技术，从而更好地保护用户数据。</p><p>四、我们如何使用cookie及相关技术</p><p>1、为实现您联机体验的个性化需求，使您获得更轻松的访问体验。</p><p>我们会在您的计算机或移动设备上发送一个或多个名为Cookies的小数据文件，指定给您的Cookies是唯一的，它只能被将Cookies发布给您的域中的Web服务器读取。我们向您发送Cookies是为了简化您重复登录的步骤，帮助判断您的登录状态以及账户或数据安全。</p>  <p>2、我们不会将 Cookies 用于本隐私政策所述目的之外的任何用途。</p><p>您可根据自己的偏好管理或删除 Cookies。您可以清除计算机上保存的所有 Cookies，大部分网络浏览器会自动接受Cookies，但您通常可根据自己的需要来修改浏览器的设置以拒绝 Cookies；另外，您也可以清除软件内保存的所有Cookies。但如果您这么做，您可能需要在每一次访问MD5.cn时亲自更改用户设置，而且您之前所记录的相应信息也均会被删除，并且可能会对您所使用服务的安全性有一定影响。</p><p>五、您如何管理自己的信息</p><p>1、访问和修改您的个人信息</p><p>您可以在使用我们服务的过程中，访问、修改和删除您提供的注册信息和其他个人信息，也可按照通知指引与我们联系。您访问、修改和删除个人信息的范围和方式将取决于您使用的具体服务。</p><p>2、删除您的个人信息</p><p>我们将按照本政策所述，仅为实现我们产品或服务的功能，收集、使用您的信息：</p><p>（1）如您发现我们违反法律、行政法规的规定使用您的个人信息，您可以要求我们删除</p><p>（2）如您发现我们收集、存储的您的个人信息有错误的，您也可以要求我们更正。</p>（3）如果我们处理个人信息的行为违反了与您的约定<p>（4）如果我们终止服务及运营。</p><p>3、在您访问、修改和删除相关信息时，我们可能会要求您进行身份验证，以保障账户的安全</p><p>4、注销账户</p><p>您可以在我们的产品中直接申请注销账户。关于您注销账户的方式以及您应满足的条件，请详见《MD5.cn账户注销须知》。 您注销账户后，我们将停止为您提供产品与/或服务，并依据您的要求，除法律法规另有规定外，我们将删除您的个人信息。</p><p>请您理解，由于技术所限、法律或监管要求，我们可能无法满足您的所有要求，我们会在合理的期限内答复您的请求。</p><p>六、我们可能向您发送的信息</p><p>1、信息推送</p><p>您在使用我们的服务时，我们可能向您发送电子邮件、短信、资讯或推送通知</p><p>您可以按照我们的相关提示，在设备上选择取消订阅。</p><p>2、与服务有关的系统消息</p><p>我们可能在必要时（例如，因系统维护而暂停某一项服务时）向您发出与服务有关的公告。</p><p>您可能无法取消这些与服务有关、性质不属于广告的公告。</p><p>七、通知和修订</p><p>我们可能适时修订本政策内容。</p><p>1、如该等变更会导致您在本政策项下权利的实质减损，我们将在变更生效前，通过在页面显著位置提示、向您发送电子邮件等方式通知您。</p><p>2、在该种情况下，若您继续使用我们的服务，即表示同意受经修订的政策约束。</p> <p>附件：《MD5.cn账户注销须知》</p><p> MD5.cn账户注销须知内容：</p><p>注销本账户后，您将放弃以下权益和资产：</p><p>1、账户信息、会员权益、账户余额、虚拟资产且无法恢复。</p><p>2、无法使用账户原验证手机或邮箱登陆MD5.cn服务。</p><p>3、解除与第三方授权或绑定关系。</p><p>您理解并同意，MD5.cn无法协助您重新恢复前述服务，您注销账户的行为会给您的售后带来诸多不便，请您在操作之前，自行备份MD5.cn账户相关的所有信息和数据，下载并保存好订单和服务的交易凭证、票据（如电子发票）等资料，否则您有可能无法享受相关服务。</p><p>勾选页面单选框，即表示您已阅读并同意《MD5.cn账户注销须知》。</p><p>您在申请注销流程中点击同意前，应当认真阅读《MD5.cn账户注销须知》（以下称“《注销须知》”）。</p><p>请您务必审慎阅读、充分理解协议中相关条款内容，其中包括：</p><p>1、与您约定免除或限制责任的条款。</p><p>2、其他以粗体标识的重要条款。</p><p>如您对本《注销须知》有任何疑问，可联系在线客服QQ 。</p><p>【特别提示】当您按照注销页面提示填写信息、阅读并同意本《注销须知》及相关条款与条件且完成全部注销程序后，即表示您已充分阅读、理解并接受本《注销须知》的全部内容。阅读本《注销须知》的过程中，如果您不同意相关任何条款和条件约定，请您立即停止账户注销程序。</p><p>亲爱的MD5.cn用户：</p><p>1. 如果您仍执意注销账户，您的账户需同时满足以下条件：</p><p>（1）自愿放弃账户在MD5.cn系统中的资产和虚拟权益（包括但不限于账户余额、可开发票等）自愿放弃。</p><p>（2）账户已经解除与第三方授权登录或绑定关系。</p><p>2. MD5.cn账户一旦被注销将不可恢复，请您在操作之前自行备份MD5.cn账户相关的所有信息和数据。请您保存好订单和服务的交易凭证、票据等资料，否则您有可能无法享受售后服务。</p><p>3 .在MD5.cn账户注销期间，如果您的账户涉及包括但不限于诉讼、仲裁、国家有权机关调查等，MD5.cn有权自行终止本MD5.cn账户的注销而无需另行得到您的同意。</p><p>4. 注销MD5.cn账户，您将无法再使用本MD5.cn账户，也将无法找回您MD5.cn账户中及与账户相关的任何内容或信息。</p><p>包括但不限于：</p><p>（1）您将无法登录、使用本MD5.cn账户。</p><p>（2）本MD5.cn账户的个人资料和历史信息（包括但不限于用户名、头像、订单、消费记录等）都将无法找回。</p><p>注销账户后，获得的余额、资格、订单、及其他权益等视为您自行放弃，将无法继续使用。您理解并同意，MD5.cn无法协助您重新恢复前述服务。请您在提交注销申请前，务必先了解，具体可与我们的客服联系。</p><p>5. 注销本MD5.cn账户并不代表本MD5.cn账户注销前的账户行为和相关责任得到豁免或减轻。</p>`,
	},
	agreementData: {
		confirm: '确认',
		content:
			'<p>欢迎您使用Magic&nbsp;Data&nbsp;5服务（下称：本服务）<br>\n' +
			'请您仔细阅下方条款，若您对本协议的任何条款存有异议，您可以第一时间选择不进入Magic&nbsp;Data&nbsp;5。<br>\n' +
			'当您注册登录成功，在进入Magic&nbsp;Data&nbsp;5后使用任意功能均意味着您（即用户）完全接受本协议项下的全部条款。<br>\n' +
			'在注册登录时，《用户协议》”处打勾“✓”并按照流程成功进入Magic&nbsp;Data&nbsp;5，即表示您已充分阅读、理解并接受本协议项下的全部内容，并与Magic&nbsp;Data&nbsp;5达成本协议。<br>\n' +
			'Magic&nbsp;Data&nbsp;5有权随时对本协议进行修改，用户在登录使用前如果不同意本协议的修改，可以放弃使用或访问本网站，如果用户选择在本协议变更后继续访问或使用本网站，则视为用户已经接受本协议的修改。</p>\n' +
			'<br>\n' +
			'<p>用户行为<br>\n' +
			'1.&nbsp;用户应遵守中华人民共和国相关法律法规，并同意对以任何方式使用用户账号而使用本服务的任何行为及其结果承担全部责任。如用户的行为违反国家法律，用户将依法承担全部法律责任；如涉嫌构成犯罪，司法机关将追究用户的刑事责任，Magic&nbsp;Data&nbsp;5将严格按照法律规定的义务及司法机关的要求进行配合。同时，如果Magic&nbsp;Data&nbsp;5有理由认为用户的任何行为，包括但不限于用户的任何言论或其它行为违反或可能违反国家法律法规的任何规定，Magic&nbsp;Data&nbsp;5可在任何时候不经任何事先通知终止向用户提供服务。<br>\n' +
			'2.&nbsp;用户应遵守所有与Magic&nbsp;Data&nbsp;5服务有关的网络协议、规定和程序。<br>\n' +
			'3.&nbsp;用户同意将不会利用Magic&nbsp;Data&nbsp;5制作、上载、复制、发布、传播或者转载如下内容：<br>\n' +
			'反对宪法所确定的基本原则的；<br>\n' +
			'危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；<br>\n' +
			'损害国家荣誉和利益的；<br>\n' +
			'煽动民族仇恨、民族歧视，破坏民族团结的；<br>\n' +
			'侮辱、滥用英烈形象，否定英烈事迹，美化粉饰侵略战争行为的；<br>\n' +
			'破坏国家宗教政策，宣扬邪教和封建迷信的；<br>\n' +
			'散布谣言，扰乱社会秩序，破坏社会稳定的；<br>\n' +
			'散布淫秽、赌博、暴力、凶杀、自残、恐怖或者教唆犯罪的；<br>\n' +
			'侮辱或者诽谤他人，侵害他人合法权益（如名誉权、肖像权等）的；<br>\n' +
			'侵害他人知识产权、商业秘密等合法权利的；<br>\n' +
			'虚构事实、隐瞒真相以误导、欺骗他人的；<br>\n' +
			'发布、传送、传播广告信息及垃圾信息的；<br>\n' +
			'其他法律法规禁止的行为。<br>\n' +
			'4.&nbsp;不得侵犯其他任何第三方的专利权、著作权、商标权、名誉权或其他任何合法权益。<br>\n' +
			'5.&nbsp;如用户在使用网络服务时违反任何上述规定，Magic&nbsp;Data&nbsp;5或其授权的人有权要求用户改正或直接采取一切必要的措施（包括但不限于更改或删除用户张贴的内容等、暂停或终止用户使用网络服务的权利）以减轻用户不当行为造成的影响。<br>\n' +
			'<br>\n' +
			'隐私保护<br>\n' +
			'1.&nbsp;保护用户个人信息安全既是法律要求，也是Magic&nbsp;Data&nbsp;5长期坚持的一项基本原则。Magic&nbsp;Data&nbsp;5保证不对外公开或向第三方提供单个用户的注册资料及用户在使用Magic&nbsp;Data&nbsp;5服务时存储在网站的非公开内容，但下列情况除外：<br>\n' +
			'事先获得用户的明确授权；<br>\n' +
			'根据有关的法律法规要求；<br>\n' +
			'按照相关政府主管部门的要求；<br>\n' +
			'为维护社会公众的利益；<br>\n' +
			'为维护网站的合法权益。<br>\n' +
			'2.&nbsp;Magic&nbsp;Data&nbsp;5可能会与第三方合作向用户提供相关的网络服务，在此情况下，如该第三方同意承担与Magic&nbsp;Data&nbsp;5同等的保护用户隐私的责任，则网站有权将用户的注册资料等提供给该第三方。<br>\n' +
			'3.&nbsp;在不透露单个用户隐私资料的前提下，Magic&nbsp;Data&nbsp;5有权对整个用户数据库进行分析并对用户数据库进行商业上的利用。<br>\n' +
			'4.&nbsp;您使用或继续使用我们的服务，即意味着同意我们按照Magic&nbsp;Data&nbsp;5《隐私政策》收集、使用、储存和分享您的相关信息。详情请参见Magic&nbsp;Data&nbsp;5《隐私政策》</p>\n' +
			'\n' +
			'<p>隐私政策<br>\n' +
			'Magic&nbsp;Data&nbsp;5非常重视对您的个人隐私保护，有时候我们需要某些信息才能为您提供您请求的服务，本隐私政策（以下简称“本政策”）解释了这些情况下的数据收集和使用情况。<br>\n' +
			'本政策适用于Magic&nbsp;Data&nbsp;5的所有相关服务，随着Magic&nbsp;Data&nbsp;5服务范围的扩大，隐私政策的内容可由Magic&nbsp;Data&nbsp;5随时更新，且毋须另行通知。更新后的隐私政策一旦在网页上公布即有效代替原来的隐私政策。<br>\n' +
			'在使用Magic&nbsp;Data&nbsp;5各项服务前，请您务必仔细阅读并透彻理解本政策，并做出您认为适当的选择。一旦您开始使用Magic&nbsp;Data&nbsp;5的各项服务，即表示您已充分理解并同意本政策。需要提醒您注意，本隐私政策仅适用于我们所收集的信息，不适用于通过我们的服务而接入的第三方服务（包括任何第三方网站）收集的信息以及通过在我们服务中进行广告服务的其他公司或机构所收集的信息。<br>\n' +
			'我们根据合法、正当、必要的原则，仅收集实现产品功能所必要的信息。<br>\n' +
			'1.&nbsp;您在使用我们服务时主动提供的信息：<br>\n' +
			'您通过注册账号时所使用的账户名称、头像、手机号码和邮箱地址及其他账号资料信息等。<br>\n' +
			'2.&nbsp;您通过我们的客服或参加我们举办的活动时所提交的信息：<br>\n' +
			'您参与我们线上活动时填写的调查问卷中可能包含您的姓名、电话、家庭地址等信息。我们的部分服务可能需要您提供特定的个人敏感信息来实现特定功能。若您选择不提供该类信息，则可能无法正常使用服务中的特定功能，但不影响您使用服务中的其他功能。<br>\n' +
			'若您主动提供您的个人敏感信息，即表示您同意我们按本政策所述目的和方式来处理您的个人敏感信息。<br>\n' +
			'免责声明<br>\n' +
			'1.&nbsp;用户明确同意其使用Magic&nbsp;Data&nbsp;5服务所存在的风险将完全由其自己承担；因其使用Magic&nbsp;Data&nbsp;5服务而产生的一切后果也由其自己承担，Magic&nbsp;Data&nbsp;5对用户不承担任何责任。<br>\n' +
			'2.&nbsp;Magic&nbsp;Data&nbsp;5不担保网络服务一定能满足用户的要求，也不担保网络服务不会中断，对网络服务的及时性、安全性、准确性也都不作担保。<br>\n' +
			'3.&nbsp;Magic&nbsp;Data&nbsp;5不保证为向用户提供便利而设置的外部链接的准确性和完整性，同时，对于该等外部链接指向的不由Magic&nbsp;Data&nbsp;5实际控制的任何网页上的内容，网站不承担任何责任。<br>\n' +
			'4.&nbsp;对于因不可抗力或不能控制的原因造成的网络服务中断或其它缺陷，Magic&nbsp;Data&nbsp;5不承担任何责任，但将尽力减少因此而给用户造成的损失和影响。<br>\n' +
			'5.&nbsp;用户同意，对于Magic&nbsp;Data&nbsp;5向用户提供的下列产品或者服务的质量缺陷本身及其引发的任何损失，Magic&nbsp;Data&nbsp;5无需承担任何责任：<br>\n' +
			'向用户免费提供的各项网络服务；<br>\n' +
			'向用户赠送的任何产品或者服务；<br>\n' +
			'向收费网络服务用户附赠的各种产品或者服务。<br>\n' +
			'协议修改<br>\n' +
			'1.&nbsp;根据互联网的发展和有关法律、法规及规范性文件的变化，或者因业务发展需要，Magic&nbsp;Data&nbsp;5有权对本协议的条款作出修改或变更，一旦本协议的内容发生变动，Magic&nbsp;Data&nbsp;5将会直接在网站上公布修改之后的协议内容，该公布行为视为Magic&nbsp;Data&nbsp;5已经通知用户修改内容。Magic&nbsp;Data&nbsp;5也可采用电子邮件或私信的传送方式，提示用户协议条款的修改、服务变更、或其它重要事项。<br>\n' +
			'2.&nbsp;如果不同意Magic&nbsp;Data&nbsp;5对本协议相关条款所做的修改，用户有权停止使用网络服务。如果用户继续使用网络服务，则视为用户接受Magic&nbsp;Data&nbsp;5对本协议相关条款所做的修改。<br>\n' +
			'3.&nbsp;本协议项下Magic&nbsp;Data&nbsp;5对于用户所有的通知均可通过网页公告、电子邮件、手机短信或常规的信件传送等方式进行；该等通知于发送之日视为已送达收件人。<br>\n' +
			'4.&nbsp;用户对于Magic&nbsp;Data&nbsp;5的通知应当通过网站对外正式公布的通信地址、传真号码、电子邮件地址等联系信息进行送达。<br>\n' +
			'其他规定<br>\n' +
			'1.&nbsp;如双方就本协议内容或其执行发生任何争议，双方应尽量友好协商解决；协商不成时，任何一方均可向Magic&nbsp;Data&nbsp;5所在地的人民法院提起诉讼。<br>\n' +
			'2.&nbsp;本协议构成双方对本协议之约定事项及其他有关事宜的完整协议，除本协议规定的之外，未赋予本协议各方其他权利。<br>\n' +
			'3.&nbsp;如本协议中的任何条款无论因何种原因完全或部分无效或不具有执行力，本协议的其余条款仍应有效并且有约束力。<br>\n' +
			'4.&nbsp;本协议中的标题仅为方便而设，在解释本协议时应被忽略。</p>',
	},
};
